import * as React from "react";

import { AddressForm } from "kanopi-components/AddressInput/AddressForm";

import { WidthContainer } from "../../ChatFlow/WidthContainer";
import PropTypes from "prop-types";

export const AddressInput = (props) => {
  const { label, help, error, validating, ...restProps } = props;
  return (
    <WidthContainer center={false}>
      <AddressForm
        label={label}
        caption={help}
        error={error}
        isValidating={validating}
        clearable={false}
        {...restProps}
      />
    </WidthContainer>
  );
};

AddressInput.propTypes = {
  label: PropTypes.string.isRequired,
  help: PropTypes.string,
  error: PropTypes.string,
  validating: PropTypes.bool,
};

export default AddressInput;
